export const API_BASE = process.env.REACT_APP_ORA_API_URL ?? 'http://localhost:8080/api/v1'
console.log('ORA_API_URL=', process.env.REACT_APP_ORA_API_URL)
console.log('API_BASE=',API_BASE)
